import { SVGProps, Ref, forwardRef } from 'react';

export const EllipsisHorizontalOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M3.25 7.083c.389 0 .6.126.72.271.13.156.197.383.197.646l-.013.19a.9.9 0 0 1-.183.456c-.121.145-.332.271-.721.271s-.6-.126-.72-.271C2.4 8.49 2.332 8.263 2.332 8s.067-.49.196-.646c.121-.145.332-.271.721-.271Zm4.75 0c.389 0 .6.126.72.271.13.156.197.383.197.646l-.013.19a.9.9 0 0 1-.183.456c-.121.145-.332.271-.721.271s-.6-.126-.72-.271c-.13-.156-.197-.383-.197-.646s.067-.49.196-.646c.121-.145.332-.271.721-.271Zm4.75 0c.389 0 .6.126.72.271.13.156.197.383.197.646s-.067.49-.196.646c-.121.145-.332.271-.721.271s-.6-.126-.72-.271c-.13-.156-.197-.383-.197-.646s.067-.49.196-.646c.121-.145.332-.271.721-.271Z"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth={0.667}
                />
            </g>
        </svg>
    )
);
EllipsisHorizontalOutlinedSize16Glyph.displayName = 'EllipsisHorizontalOutlinedSize16Glyph';
